import { CITE_BRACKET, citationIds as groupCitationIds, normalizeAskCitations } from "./askCitations";

/** Historical labels are context only, never citations in a new answer. */
const HISTORICAL = String.raw`(?:\\?\[\s*earlier\s+(?:R\d+|source\s+\d+)(?:\s*,\s*(?:earlier\s+)?R\d+)*\s*\\?\]|\(earlier source \d+\))`;

export function hasHistoricalCitations(text: string): boolean {
  return new RegExp(HISTORICAL, "i").test(text);
}

export function citationIds(text: string): string[] {
  return [...text.matchAll(new RegExp(CITE_BRACKET, "g"))].flatMap(match => groupCitationIds(match[1]!));
}

/** Also used on saved answers so old malformed replies cannot leak labels. */
export function cleanAskCitations(text: string, knownIds: string[]): string {
  return normalizeAskCitations(
    text.replace(new RegExp(`[ \\t]*${HISTORICAL}`, "gi"), ""),
    knownIds.map(id => ({ id })),
  );
}
